import { UserProps } from '../../constants/Common';
import firebaseApi from '../../firebase/firebaseApi';
import { DefaultEmployeeRates } from './DefaultEmployeeRates';

export const DefaultEmployeeRatesWrapper = ({
	userDetails,
}: UserProps): JSX.Element => (
	<DefaultEmployeeRates userDetails={userDetails} firebaseApi={firebaseApi} />
);
